import cn from 'classnames';
import React, { FC, PropsWithChildren, memo } from 'react';

import Typography from '@mui/material/Typography';

import useStyles from './styles.module';

interface Props extends PropsWithChildren {
  className?: string;
  title?: string;
}

const Box: FC<Props> = ({ className, children, title }) => {
  const { classes } = useStyles();

  return (
    <div
      className={cn(classes.box, { [classes.boxTitle]: !!title }, className)}
    >
      {title && (
        <Typography variant="body1" color={(theme) => theme.secondary.s3}>
          {title}
        </Typography>
      )}
      {children}
    </div>
  );
};

export default memo(Box);
